import React from 'react'
import I01 from '../assets/img/01.png'
import I10 from '../assets/img/10.png'
export const Filter = () => {
  return (
    <>
        <ul id="bgAnimation">
            <li><img src={I01} alt="01"/></li>
            <li><img src={I10} alt="01"/></li>
            <li><img src={I01} alt="01"/></li>
            <li><img src={I10} alt="01"/></li>
            <li><img src={I01} alt="01"/></li>
            <li><img src={I10} alt="01"/></li>
            <li><img src={I01} alt="01"/></li>
            <li><img src={I10} alt="01"/></li>
        </ul>
    </>
  )
}
